import React, {
  useState,
  useMemo,
  useCallback,
  useRef,
  useEffect,
} from 'react';
import { toast } from 'react-toastify';

import { IconButton, Badge, Menu, Button } from '@material-ui/core';
import { Search } from '@material-ui/icons';
import { Form } from '@unform/web';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';

import { Checkbox } from '~/components/Form';

import * as S from './styles';

export default function Filters({ onCallback }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [loading, setLoading] = useState(false);

  const formRef = useRef(null);
  const options = useMemo(
    () => [
      { id: 'T', label: 'Terminal' },
      { id: 'Q', label: 'Tancagem' },
      { id: 'S', label: 'Turno do Posto' },
      { id: 'O', label: 'Saldo Insuficiente' },
    ],
    []
  );

  const [data, setData] = useState(options.map((op) => op.id));

  const handleOpenMenu = useCallback((event) => {
    setAnchorEl(event.currentTarget);
  }, []);

  const handleCloseMenu = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const handleSubmit = useCallback(async (formData) => {
    try {
      setLoading(true);

      const checkeds = Object.keys(formData).filter((key) => formData[key]);

      setData(checkeds);

      if (isEmpty(checkeds)) {
        toast.error('Selecione ao menos um item para iniciar a pesquisa.');
        return;
      }

      onCallback({ camposPesquisa: checkeds });
      handleCloseMenu();
    } catch (error) {
      console.info('Wrong!', error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    onCallback({ camposPesquisa: options.map((op) => op.id) });
  }, [options]);

  return (
    <S.Wrapper>
      <IconButton
        aria-label="filtro"
        aria-controls="simple-menu-alerts"
        aria-haspopup="true"
        onClick={handleOpenMenu}
      >
        <Badge
          color="primary"
          variant="dot"
          invisible={data.length === Object.keys(options).length}
        >
          <Search />
        </Badge>
      </IconButton>

      <Form ref={formRef} onSubmit={handleSubmit}>
        <Menu
          keepMounted
          id="simple-menu-alerts"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleCloseMenu}
        >
          <S.ContainerForm>
            {options.map((option) => (
              <Checkbox
                checked
                key={option.id}
                name={option.id}
                label={option.label}
              />
            ))}

            <Button
              variant="contained"
              color="primary"
              size="small"
              disabled={loading}
              onClick={() => formRef.current.submitForm()}
            >
              Pesquisar
            </Button>
          </S.ContainerForm>
        </Menu>
      </Form>
    </S.Wrapper>
  );
}

Filters.propTypes = {
  onCallback: PropTypes.func.isRequired,
};
